export { default } from './ScheduledBundleHistoryTable';
